export * from "./landing";
export * from "./who-we-help";
export * from "./faq";
export * from "./aboutus";
export * from "./realtors";
export * from "./business-owners";

import emails from "./emails.json";
import schedules from "./schedules.json";
import tasks from "./tasks.json";
import notifications from "./notifications.json";
import emailNotif from "./emailnotif.json";

export { emails, schedules, tasks, notifications, emailNotif }